<script>
import Vue from 'vue';
import Numeral from 'numeral';

export default {
    name: 'tile',

    props: {
        label: {
            type: String,
            default: null
        },

        icon: {
            type: String,
            default: null
        },

        link: {
            type: String,
            default: 'javascript:;'
        },

        isActive: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        tileClass() {
            return {
                'tile-container': true,
                'tile--white': true,
                'is-active': this.isActive
            }
        }
    },

    methods: {
        onClick() {
            this.$emit('click', this.isActive);
        }
    }
}
</script>

<template>
    <a :href="link" class="tile-link" @click="onClick">
        <div :class="tileClass">
            <div class="tile-logo">
                <slot name="icon">
                    <i :class="icon"></i>
                </slot>
            </div>
            <p class="tile-btn">
                <slot>{{label}}</slot>
            </p>
        </div>
    </a>
</template>